import cssVars from 'css-vars-ponyfill'
import App from './App.svelte'

const app = new App({
  target: document.body,
})

cssVars()

export default app
